import React from 'react';
import PropTypes from 'prop-types';

const MrCleanRenderer = ({ value }) => {
  return (
    <React.Fragment>
      {value.map(({ link, label }) => (
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          key={link}
          style={{ display: 'inline-block', marginRight: 5 }}
        >
          {label}
        </a>
      ))}
    </React.Fragment>
  );
};

MrCleanRenderer.propTypes = {
  value: PropTypes.array.isRequired,
};

export default MrCleanRenderer;
